<template>
  <ul
    role="tablist"
    class="nav nav-tabs"
  >
    <li class="nav-item">
      <a
        data-toggle="tab"
        role="tab"
        class="nav-link"
        :class="{ 'active': isRegActive }"
        @click="$emit('setIsRegisterActive', true)"
      >
        <!-- class="sprite-icon olymp-magnifying-glass-icon" -->
        <app-icon
          name="olymp-login-icon"
          color="gray"
          size="medium"
        />
      </a>
    </li>
    <li class="nav-item">
      <a
        data-toggle="tab"
        role="tab"
        class="nav-link"
        :class="{ 'active': !isRegActive }"
        @click="$emit('setIsRegisterActive', false)"
      >
        <!-- sprite-icon left-menu-icon -->
        <app-icon
          name="olymp-register-icon"
          color="gray"
          size="medium"
        />
      </a>
    </li>
  </ul>
</template>

<script>
  import AppIcon from '../common/AppIcon'
export default {
  name: 'NavTabs',
  components: { AppIcon },
  props: {
    isRegActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {}

}
</script>
